import styled from '@emotion/styled'
import WysiwygBase from '@/components/Wysiwyg'

import { ButtonWrapper as Button } from '@/components/Button/style'

import { mediaMax } from '@/styles/mixins'

export const Container = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 120rem;
  margin: 4rem auto;
  padding: 0 15px;

  ${mediaMax.xs} {
    width: 90%;
  }
`

export const TextContainer = styled.div`
  width: 70%;

  ${mediaMax.md} {
    width: 75%;
  }

  ${mediaMax.xs} {
    width: 90%;
  }
`

export const TextWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  //margin-top: 4rem;

  .halfBlock {
    width: 45%;
  }

  ${mediaMax.md} {
    flex-direction: column;
    justify-content: flex-start;
    //margin-top: 2rem;

    .halfBlock {
      width: 100%;
      margin-bottom: ${({ theme }) => theme.spacing.xsmall};
    }
  }
`

export const Wysiwyg = styled(WysiwygBase)`
  p, h5, h6 {
    line-height: 150%;
    letter-spacing: -0.03rem;
  }

  p {
    color: ${({ theme }) => theme.colors.grey};
  }

  ${mediaMax.xs} {
    p {
      width: 100%;
    }
  }
`

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: auto;

  ${Button} {
    width: fit-content;
  }
`
